import { combineReducers, configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./sagas/rootSaga";
import CartSlice from "./slices/cartSlice";
import IntegratedGoogleSuggestionSlice from "./slices/common/integratedGoogleSuggestion";
import CommonSlice from "./slices/commonSlice";
import EarliestDeliveryDatesSlice from "./slices/earliestDeliveryDatesSlice";
import LocationLockSlice from "./slices/locationLock";
import { registerMapFormLocationGetter } from "../utils/common";
import LoginSignupSlice from "./slices/loginSignupSlice";
import PDPSlice from "./slices/pdpSlice";
import PLPSlice from "./slices/plpSlice";
import GiftFinderSlice from "./slices/giftFinderSlice";
import webFeatureControls from "./slices/webFeatureControls";
import ShippingDateAndSlotSelectionSlice from "./slices/common/shippingDateAndSlotSelection";
import AppConfigSlice from "./slices/common/appConfig";
import FusSlice from "./slices/common/fus";
import AddOnSlice from "./slices/common/addOn";
import CurrencyListSlice from "./slices/common/currencyLists";
import FnpCashSlice from "./slices/fnpCash";
import PersonalizationSlice from "./slices/personalizationSlice";
import SavedAddressesSlice from "./slices/savedAddresses";
import lottieIconsSlice from "./slices/lottieIconsSlice";
import PDPAddOn from "./slices/pdpAddonSlice";
import SecretSantaSlice from "./slices/secretSantaSlice";
import DynamicHomeSlice from "./slices/dynamicHomeSlice";
import ReminderSlice from "./slices/reminder";
import DeliveryAddressSlice from "./slices/deliveryAddress";
import PartnerInfoSlice from "./slices/partner";
import MyAccountSlice from "./slices/myAccount";
import AccountAddressBookSlice from "./slices/accountAddressBook";
import OrderModificationSlice from "./slices/orderModification";
const sagaMiddleware = createSagaMiddleware();
const storeMiddleware = [sagaMiddleware];

const appReducer = combineReducers({
  cart: CartSlice,
  plp: PLPSlice,
  giftFinder: GiftFinderSlice,
  deliveryDate: EarliestDeliveryDatesSlice,
  loginSignUp: LoginSignupSlice,
  webFeatureControls: webFeatureControls,
  common: CommonSlice,
  pdp: PDPSlice,
  pincodeLocationSuggestion: IntegratedGoogleSuggestionSlice,
  locationLock: LocationLockSlice,
  personalization: PersonalizationSlice,
  shippingDateAndSlotSelection: ShippingDateAndSlotSelectionSlice,
  appConfig: AppConfigSlice,
  fus: FusSlice,
  addOn: AddOnSlice,
  currencyList: CurrencyListSlice,
  fnpCash: FnpCashSlice,
  savedAddress: SavedAddressesSlice,
  lottieIcons: lottieIconsSlice,
  pdpAddon: PDPAddOn,
  secretSanta: SecretSantaSlice,
  dynamicHome: DynamicHomeSlice,
  reminder: ReminderSlice,
  deliveryAddress: DeliveryAddressSlice,
  partnerInfo: PartnerInfoSlice,
  myAccount: MyAccountSlice,
  accountAddressBook: AccountAddressBookSlice,
  orderModification: OrderModificationSlice,
});

/**
 *
 * @param {*} state
 * @param {*} action
 * @returns
 */
const rootReducer = (state, action) => {
  return appReducer(state, action);
};
// const persistedReducer = persistReducer(persistConfig, rootReducer);

const _store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    }).concat(storeMiddleware);
  },
});
sagaMiddleware.run(rootSaga);
registerMapFormLocationGetter(() => _store.getState()?.locationLock?.mapFormLocation);
// export const _persistorStore = persistStore(_store);
export default _store;
